import { ArrowRight, LogIn } from 'lucide-react'
import { LANDING_PAGE_ROUTE, LANDING_PAGE_UI } from '@propbix/constants/public'
import { ButtonLink } from '@/components/Button'
import { Reveal } from '@/components/Reveal'
import { tenantAppHref } from '@/lib/tenant-app-url'

export function FinalCta() {
  return (
    <section className="section-band-ink" aria-labelledby="final-heading">
      <div className="page-shell section-y">
        <Reveal className="mx-auto max-w-2xl text-center">
          <h2
            id="final-heading"
            className="font-display text-[clamp(1.95rem,3.4vw,2.9rem)] font-semibold tracking-[-0.04em] leading-[1.08] text-white"
          >
            {LANDING_PAGE_UI.finalTitle}
          </h2>
          <p className="mx-auto mt-5 max-w-[54ch] text-base leading-7 text-slate-300 md:text-lg">
            {LANDING_PAGE_UI.finalSubtitle}
          </p>
          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <ButtonLink
              variant="primary"
              href={tenantAppHref(LANDING_PAGE_ROUTE.signup)}
              className="bg-white text-brand hover:bg-accentSoft dark:bg-white dark:text-brand dark:hover:bg-accentSoft"
            >
              {LANDING_PAGE_UI.finalPrimaryCta}
              <ArrowRight size={16} strokeWidth={2} />
            </ButtonLink>
            <ButtonLink
              variant="secondary"
              href={tenantAppHref(LANDING_PAGE_ROUTE.login)}
              className="border-white/25 bg-transparent text-white hover:border-white/45 hover:bg-white/10"
            >
              <LogIn size={16} strokeWidth={1.75} />
              {LANDING_PAGE_UI.finalSecondaryCta}
            </ButtonLink>
          </div>
        </Reveal>
      </div>
    </section>
  )
}
